/* eslint-disable no-nested-ternary */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable max-len */
/* eslint-disable import/no-cycle */
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import {
  Button, Checkbox, Space,
  Spin
} from 'antd';
import React, { useEffect, useMemo } from 'react';
import {
  Controller, useFieldArray, UseFormReturn, useWatch
} from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import Input from 'common/components/Input';
import mapModifiers from 'common/utils/functions';
import { FormTierValues, FormValues } from 'extends/AddOnPackageDetail';

export type TableFieldType = {
  key: string;
  label: string;
  type: string;
  dependency?: string;
};

type CustomServiceType = {
  id: number;
  slug: string;
  text: string;
};

interface PackageTierConfigProps {
  method: UseFormReturn<FormValues>;
  customServicesData?: CustomServiceType[];
  isDisplay?: boolean;
  tiersData?: FormTierValues[];
  isLoading?: boolean;
}

const PackageTierConfig = ({
  method, isDisplay, isLoading
}: PackageTierConfigProps) => {
  /* Hook */
  const { t } = useTranslation();

  const formWatchType = useWatch({
    control: method.control,
    name: 'type',
  });

  const isAgentType = formWatchType && formWatchType.label === 'Agent';
  const isKnowledgeBaseType = formWatchType && formWatchType.label === 'Knowledge base';
  const isSessionsType = formWatchType && formWatchType.label === 'Session';
  const tableRowHeaders = [
    {
      key: 'general',
      label: t('package.general'),
      children:
        isAgentType
          ? [{ key: 'general.numberOfAgent', label: t('package.numberOfAgent'), type: 'number' }] : []
    },
    {
      key: 'knowledgeLimits',
      label: t('package.knowledgeBaseLimit'),
      children: isKnowledgeBaseType
        ? [
          { key: 'knowledgeLimits.numberOfFile', label: t('package.numberOfFile'), type: 'number' },
          { key: 'knowledgeLimits.totalSizeLimit', label: t('package.totalSizeLimit'), type: 'number' },
          { key: 'knowledgeLimits.numberOfWebsite', label: t('package.numberOfWeb'), type: 'number' },
        ] : []
    },
    {
      key: 'endUserSides',
      label: t('package.endUserSides'),
      children: isSessionsType
        ? [{ key: 'endUserSides.numberOfSession', label: t('package.numberOfSession'), type: 'number' }] : []
    }
  ].filter((row) => row.children.length > 0);

  // Functions
  const getAllChildrenFields = () => {
    const childrenFields: Array<TableFieldType> = [];
    tableRowHeaders.forEach((row) => {
      row.children.forEach((child) => {
        childrenFields.push(child);
      });
    });
    return childrenFields;
  };

  if (isLoading) {
    return <Spin />;
  }

  return (
    <div>
      <Space direction="vertical" className="u-mt-16 p-packageDetail_tierConfig_wrapper">
        <div className="p-packageDetail_tierConfig_table_wrapper">
          <table className="p-packageDetail_tierConfig_table">
            {tableRowHeaders?.map((row) => (
              <>
                <tr key={row?.key}>
                  <th style={{ minWidth: '200px' }} rowSpan={row.children.length}>{row?.label}</th>
                  <td style={{ minWidth: '400px' }}>{row.children[0]?.label}</td>
                </tr>
                {row?.children.slice(1).map((child) => (
                  <tr key={child?.key}>
                    <td>{child?.label}</td>
                  </tr>
                ))}
              </>
            ))}

            <tr className="p-packageDetail_tierConfig_table_seperator">
              <td />
              <td />
            </tr>

            <tr>
              <th className="p-packageDetail_tierConfig_table_firstHeader">{t('package.cost')}</th>
              <td>{t('package.vnd')}</td>
            </tr>
          </table>
          <div className={mapModifiers('p-packageDetail_tierConfig_table', 'empty')}>
            {getAllChildrenFields()?.map((row) => (
              <Controller
                key={row.key}
                name={`tiers.${row.key}` as 'tiers.name' | 'tiers.general' | 'tiers.knowledgeLimits' | 'tiers.endUserSides' | 'tiers.price'}
                render={({ field: colField, fieldState: { error } }) => (
                  <div className="p-packageDetail_tierConfig_table_row" key={`tiers.${row.key}`}>
                    {row.type === 'checkbox' ? (
                      <Checkbox
                        {...colField}
                        onChange={(e) => {
                          if (isDisplay) return;
                          colField.onChange(e.target.checked);
                        }}
                        value={!!colField.value}
                        checked={!!colField.value}
                        disabled
                        className={mapModifiers('p-packageDetail_tierConfig_table_row_checkbox')}
                      />
                    ) : (
                      <>
                        <Input
                          {...colField}
                          disabled={isDisplay}
                          className="p-packageDetail_tierConfig_table_row_input"
                          value={colField.value as number}
                          onChange={(e) => colField.onChange(Number(e.target.value))}
                          type="number"
                        />
                        {error?.message && (
                          <span className="p-packageDetail_tierConfig_error">{error.message}</span>
                        )}
                      </>
                    )}
                  </div>
                )}
                control={method.control}
              />
            ))}
            <div className="p-packageDetail_tierConfig_table_seperator" />

            <Controller
              name="tiers.price"
              render={({ field: colField }) => (
                <div className="p-packageDetail_tierConfig_table_row" key="tiers.price">
                  <Input {...colField} disabled={isDisplay} type="number" onChange={(e) => colField.onChange(Number(e.target.value))} className="p-packageDetail_tierConfig_table_row_input" />
                </div>
              )}
              control={method.control}
            />
          </div>
        </div>
      </Space>
    </div>
  );
};

export default PackageTierConfig;
